import { CALL_API, METHOD_TYPE } from '../../middleware/api.middleware'

export const GET_CONTACT_EDIT_REQUEST = 'GET_CONTACT_EDIT_REQUEST'
export const GET_CONTACT_EDIT_SUCCESS = 'GET_CONTACT_EDIT_SUCCESS'
export const GET_CONTACT_EDIT_FAILURE = 'GET_CONTACT_EDIT_FAILURE'
export const CREATE_CONTACT_REQUEST = 'CREATE_CONTACT_REQUEST'
export const CREATE_CONTACT_SUCCESS = 'CREATE_CONTACT_SUCCESS'
export const CREATE_CONTACT_FAILURE = 'CREATE_CONTACT_FAILURE'
export const UPDATE_CONTACT_REQUEST = 'UPDATE_CONTACT_REQUEST'
export const UPDATE_CONTACT_SUCCESS = 'UPDATE_CONTACT_SUCCESS'
export const UPDATE_CONTACT_FAILURE = 'UPDATE_CONTACT_FAILURE'
export const SEARCH_INSTITUTION_REQUEST = 'SEARCH_INSTITUTION_REQUEST'
export const SEARCH_INSTITUTION_SUCCESS = 'SEARCH_INSTITUTION_SUCCESS'
export const SEARCH_INSTITUTION_FAILURE = 'SEARCH_INSTITUTION_FAILURE'
export const SEARCH_INSTITUTIONS_REQUEST = 'SEARCH_INSTITUTIONS_REQUEST'
export const SEARCH_INSTITUTIONS_SUCCESS = 'SEARCH_INSTITUTIONS_SUCCESS'
export const SEARCH_INSTITUTIONS_FAILURE = 'SEARCH_INSTITUTIONS_FAILURE'
export const SEARCH_FUNDS_REQUEST = 'SEARCH_FUNDS_REQUEST'
export const SEARCH_FUNDS_SUCCESS = 'SEARCH_FUNDS_SUCCESS'
export const SEARCH_FUNDS_FAILURE = 'SEARCH_FUNDS_FAILURE'
export const RESET_FORM = 'RESET_FORM'
export const RESET_SUGGESTIONS = 'RESET_SUGGESTIONS'

/**
 * Create Contact
 * @param data
 * @private
 */
const _createContact = (data) => ({
  [CALL_API]: {
    types: [
      CREATE_CONTACT_REQUEST,
      CREATE_CONTACT_SUCCESS,
      CREATE_CONTACT_FAILURE
    ],
    method: METHOD_TYPE.POST,
    endpoint: '/contact/create',
    payload: data
  }
})

/**
 * Update Contact
 * @param id
 * @param data
 * @returns {{}}
 * @private
 */
const _updateContact = (id, data) => ({
  [CALL_API]: {
    types: [
      UPDATE_CONTACT_REQUEST,
      UPDATE_CONTACT_SUCCESS,
      UPDATE_CONTACT_FAILURE
    ],
    method: METHOD_TYPE.PUT,
    endpoint: `/contact/${id}`,
    payload: data
  }
})

/**
 * Search Institution By Id
 * @param id
 * @param options
 * @returns {{}}
 * @private
 */
const _searchInstitution = (id, options = {}) => ({
  [CALL_API]: {
    types: options.types || [
      SEARCH_INSTITUTION_REQUEST,
      SEARCH_INSTITUTION_SUCCESS,
      SEARCH_INSTITUTION_FAILURE
    ],
    method: METHOD_TYPE.GET,
    endpoint: `/institution/search/${id}`
  }
})

/**
 * Search Institutions
 * @param params
 * @param options
 * @returns {{}}
 * @private
 */
const _searchInstitutions = (params, options = {}) => ({
  [CALL_API]: {
    types: options.types || [
      SEARCH_INSTITUTIONS_REQUEST,
      SEARCH_INSTITUTIONS_SUCCESS,
      SEARCH_INSTITUTIONS_FAILURE
    ],
    method: METHOD_TYPE.GET,
    endpoint: '/institutions/search',
    payload: { ...params, limit: 20 }
  }
})

/**
 * Search Funds
 * @param params
 * @param options
 * @returns {{}}
 * @private
 */
const _searchFunds = (params, options = {}) => ({
  [CALL_API]: {
    types: options.types || [
      SEARCH_FUNDS_REQUEST,
      SEARCH_FUNDS_SUCCESS,
      SEARCH_FUNDS_FAILURE
    ],
    method: METHOD_TYPE.GET,
    endpoint: '/fund/search',
    payload: { ...params, page: 1, limit: 20 }
  }
})

/**
 * Create revision object to push
 * @param notes
 * @param profile
 * @returns {{notes: (*|string), author: (*|string), update_date: Date}}
 */
const getRevisionObject = (notes, profile) => {
  return {
    update_date: new Date(),
    author: profile && profile.name,
    notes: notes.trim()
  }
}

/**
 * Convert contact form values to model expected from API
 * @param data
 * @param profile
 * @returns {*}
 * @private
 */
const _createContactPayload = (data, profile) => {
  if (!data) {
    return {}
  }

  return {
    id: data._id,
    source: 'people_ssot',
    status: data.status || null,
    salutation: data.salutation,
    suffix_prof: data.suffixProf,
    first_name: data.firstName,
    last_name: data.lastName,
    full_name: []
      .concat(data.firstName, data.lastName)
      .filter((name) => name && name.trim()).join(' '),
    nickname: data.nickName,
    middle_name1: '', // @deprecated
    middle_name2: '', // @deprecated
    maternal_name: '', // @deprecated
    maiden_name: '', // @deprecated
    first_name_pronunciation: '', // @deprecated
    last_name_pronunciation: '', // @deprecated
    email: data.email,
    direct_phone: data.directPhone,
    phone_extension: data.directPhone ? data.phoneExtension : '',
    mobile: data.mobile,
    linkedin_url: data.linkedIn,
    company_website1: data.website1,
    company_website2: data.website2,
    fca_url: data.fca,
    sec_url: data.sec,
    finra_url: data.finra,
    bio: (data.bio || '').replace(/[\r\n]/g, '\\n'),
    title: data.title,
    jobs: data.jobs || [],
    revision: (data.notes && data.notes.trim() && data.notes.trim().length) ? getRevisionObject(data.notes, profile) : null,
    managed_funds: data.managedFunds || [],
    gdpr: data.gdpr || []
  }
}

/**
 * Dispatch CREATE_CONTACT_REQUEST
 * @param params: data, profile
 */
export const createContact = (params) => (dispatch) => {
  const data = _createContactPayload(params.values, params.profile)
  return dispatch(_createContact(data))
}

/**
 * Dispatch UPDATE_CONTACT_REQUEST
 * @param params: id, data, profile
 * @returns {function(*)}
 */
export const updateContact = (params) => (dispatch) => {
  const id = params.values && params.values.id
  const data = _createContactPayload(params.values, params.profile)
  return dispatch(_updateContact(id, data))
}

/**
 * Reset Form - resets reducer back to initial state
 */
export const resetForm = () => (dispatch) => {
  return dispatch({ type: RESET_FORM })
}

/**
 * Dispatch SEARCH_INSTITUTION_REQUEST
 * @param id
 * @param options
 */
export const searchInstitution = (id, options) => (dispatch) => {
  return dispatch(_searchInstitution(id, options))
}

/**
 * Dispatch SEARCH_INSTITUTIONS_REQUEST
 * @param params
 * @param options
 */
export const searchInstitutions = (params, options) => (dispatch) => {
  return dispatch(_searchInstitutions(params, options))
}

/**
 * Dispatch SEARCH_FUNDS_REQUEST
 * @param params
 * @param options
 */
export const searchFunds = (params, options) => (dispatch) => {
  return dispatch(_searchFunds(params, options))
}

/**
 * Clears institution suggestions
 */
export const clearSuggestions = () => (dispatch) => {
  return dispatch({ type: RESET_SUGGESTIONS })
}
